<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="table-responsive">
        <table class="table">
          <thead class="bg-dark-purple">
            <tr>
              <td></td>
              <td class="center">
                <Header
                  name="Nome"
                  entity="Candidates"
                  field="candidate_name"
                />
              </td>
              <td class="center">
                <Header
                  name="Email"
                  entity="Candidates"
                  field="candidate_email"
                />
              </td>
              <td class="center">
                <Header
                  name="Salário"
                  entity="Candidates"
                  field="remuneration"
                />
              </td>
              <td class="center">
                <Header
                  name="Portfólio"
                  entity="Candidates"
                  field="personal_portfolio"
                />
              </td>
              <td class="center">
                <Header
                  name="Site Pessoal"
                  entity="Candidates"
                  field="personal_site"
                />
              </td>
              <td class="center">
                <Header
                  name="Linkedin"
                  entity="Candidates"
                  field="linkedin_url"
                />
              </td>
              <td class="center">
                <Header
                  name="Celular"
                  entity="Candidates"
                  field="mobile_phone"
                />
              </td>
              <td class="center">
                <Header name="Cidade" entity="Candidates" field="city" />
              </td>
              <td class="center">
                <Header name="Estado" entity="Candidates" field="state" />
              </td>

              <td class="center">
                <Header
                  name="Data criação"
                  entity="Candidates"
                  field="created_at"
                />
              </td>
              <td class="center">
                <Header
                  name="Atualização"
                  entity="Candidates"
                  field="updated_at"
                />
              </td>

              <td class="center">
                <Header name="Idade" entity="Candidates" field="date_birth" />
              </td>
              <td class="center">
                <Header name="Gênero" entity="Candidates" field="gender" />
              </td>
              <td class="center">
                <Header name="Cidade Natal" entity="Candidates" field="hometown" />
              </td>
              <td class="center">
                <Header name="Etnia" entity="Candidates" field="ethnicity" />
              </td>
              <td
                class="center"
                style="min-width: 300px;"
              >
                <Header name="Orientação Sexual" entity="Candidates" field="sexual_orientation" width="300px" />
              </td>
              <td class="center">
                <Header name="PCD" entity="Candidates" field="pcd_description" />
              </td>
              <td class="center">
                <Header
                  name="Currículo"
                  entity="Candidates"
                  field="curriculum_text"
                />
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="talent_bank in talent_banks" :key="talent_bank.id">
              <td class="center">
                <input
                  type="checkbox"
                  name="selectCandidate"
                  :value="checkboxValue(talent_bank)"
                  v-model="candidates_selected"
                />
              </td>
              <td class="">
                <inertia-link :href="`${talent_bank.id}/candidate/`">
                  <b class="color-grey-primary">{{
                    talent_bank.candidate_name
                  }}</b>
                </inertia-link>
              </td>
              <td class="color-grey">
                {{ talent_bank.candidate_email }}
              </td>
              <td class="center color-grey">
                <span v-if="talent_bank.remuneration">
                  {{
                    talent_bank.remuneration
                      | currency("R$ ", 2, {
                        decimalSeparator: ",",
                        thousandsSeparator: ".",
                      })
                  }}
                </span>
                <span v-else> NÃO INFORMADO </span>
              </td>
              <td class="center">
                <a
                  v-if="talent_bank.portifolio != ''"
                  target="_blank"
                  :href="`${talent_bank.portifolio}`"
                >
                  <i class="fas f20 color-dark-purple fa-external-link-alt"></i>
                </a>
                <span v-if="talent_bank.portifolio == ''">
                  <i class="fas f20 color-grey fa-external-link-alt"></i>
                </span>
              </td>
              <td class="center">
                <a
                  v-if="talent_bank.personal_site != ''"
                  target="_blank"
                  :href="`${talent_bank.personal_site}`"
                >
                  <i class="fas f20 color-dark-purple fa-external-link-alt"></i>
                </a>
                <span v-if="talent_bank.personal_site == ''">
                  <i class="fas f20 color-grey fa-external-link-alt"></i>
                </span>
              </td>
              <td class="center">
                <a
                  v-if="talent_bank.linkedin_url != null"
                  target="_blank"
                  :href="`${talent_bank.linkedin_url}`"
                >
                  <i class="fas f20 color-dark-purple fa-external-link-alt"></i>
                </a>
                <span v-if="talent_bank.linkedin_url == null">
                  <i class="fas f20 color-grey fa-external-link-alt"></i>
                </span>
              </td>
              <td class="center">{{ talent_bank.mobile_phone }}</td>
              <td class="center">{{ talent_bank.exterior_city || talent_bank.city_name }} </td>
              <td class="center">{{ talent_bank.state_name }}</td>
              <td class="center">
                {{ new Date(talent_bank.created_at) | date("dd/M/yyyy hh:mm") }}
              </td>
              <td class="center">
                {{ new Date(talent_bank.updated_at) | date("dd/M/yyyy hh:mm") }}
              </td>
              <td class="center">
                {{
                  formatDistanceStrict(
                    new Date(talent_bank.date_birth),
                    new Date(),
                    {
                      locale: ptBR,
                      addSuffix: false,
                    }
                  )
                }}
              </td>
              <td class="center">
                {{
                  genders[talent_bank.gender]
                    ? genders[talent_bank.gender]
                    : 'Não definido'
                }}
              </td>
              <td class="center">
                {{ talent_bank.hometown_attributes ? 
                  `${talent_bank.hometown_attributes.name}/${talent_bank.hometown_state_attributes.name}`:
                  `Não definido`
                }}
              </td>
              <td class="center">
                {{ getEthnicity(talent_bank.ethnicity) || "Não definido" }}
              </td>
              <td class="center">
                {{ getSexualOrientation(talent_bank.sexual_orientation) || "Não definido" }}
              </td>

              <td class="center">
                {{ talent_bank.is_pcd ? talent_bank.pcd_description : "Não" }}
              </td>

              <td class="center">
                <inertia-link
                  :href="`${talent_bank.id}/candidate/`"
                  class="pt-4 pointer color-dark-purple"
                >
                  <i class="fas f25 fa-file-alt"></i>
                </inertia-link>
              </td>
            </tr>
            <div
              class="center position-absolute loading-gif"
              :class="{ 'd-none': !loading || firstLoad }"
            >
              <img src="/images/loading.gif" alt="loading-gif" />
            </div>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDistanceStrict } from "date-fns";
import { ptBR } from "date-fns/locale";
import Header from "components/Table/Header.vue";
import { state } from "store/business.js";

export default {
  props: ["talent_banks"],
  components: { Header },
  data: () => ({
    formatDistanceStrict: formatDistanceStrict,
    candidates_selected: [],
    ptBR: ptBR,
    loading: false,
    firstLoad: true,
    pageCount: 1,
    state: state,
    genders: [
      "Homen",
      "Mulher",
      "Transgêneros",
      "Não identificado",
      "Não cadastrado",
    ],
    ethnicities: [
      { id: 0, name: "Indígena" },
      { id: 1, name: "Branco" },
      { id: 2, name: "Negro" },
      { id: 3, name: "Pardo" },
      { id: 4, name: "Oriental" },
      { id: 5, name: "Prefiro não informar" },
      { id: 6, name: "Indefinido" },
    ],
    sexual_orientations: [
      { id: 0, name: "Heterossexual" },
      { id: 1, name: "Bissexual" },
      { id: 2, name: "Pansexual" },
      { id: 4, name: "Homossexual" },
      { id: 3, name: "Prefiro não informar" }
    ],
  }),
  mounted() {
    eventBus.$on("resetSelected", () => {
      this.candidates_selected = [];
    });
  },
  watch: {
    candidates_selected: function () {
      eventBus.$emit("candidateSelected", this.candidates_selected);
    },
    "state.extra_options"() {
      this.setExtraOptions();
    }
  },
  methods: {
    checkboxValue(talent_bank) {
      return {
        id: talent_bank.candidate_id,
        name: talent_bank.candidate_name,
        email: talent_bank.candidate_email,
        remuneration: talent_bank.remuneration,
      };
    },
    showField(field, monetary = false) {
      if (field == null || "" || "" || field.length == 0 || field == 0) {
        return "Não Informado";
      } else {
        return monetary ? this.formatCurrency(field) : field;
      }
    },
    getEthnicity(ethnicity_id) {
      const ethnicity = this.ethnicities.find(
        (ethnicity) => ethnicity.id === ethnicity_id
      );
      if (ethnicity) {
        return ethnicity.name;
      }
      return "Não definido";
    },
    getSexualOrientation(sexual_orientation_id) {
      const sexual_orientation = this.sexual_orientations.find(
        (sexual_orientation) => sexual_orientation.id === sexual_orientation_id
      );
      if (sexual_orientation) {
        return sexual_orientation.name;
      }
      return "Não definido";
    },
    setExtraOptions() {
      if (this.state.extra_options) {
        this.state.extra_options?.gender?.length > 0 ?  
          this.genders = this.state.extra_options?.gender?.map((gender) => {
            return gender
          })
        : this.genders;
        this.state.extra_options?.ethnicity?.length > 0 ?  
          this.ethnicities = this.state.extra_options?.ethnicity?.map((ethnicity, index) => {
            return { name: ethnicity, id: index }
          }) 
        : this.ethnicities;

        this.state.extra_options?.sexual_orientation?.length > 0 ?  
          this.sexual_orientations = this.state.extra_options?.sexual_orientation?.map((sexual_orientation, index) => {
            return { name: sexual_orientation, id: index }
          })
        : this.sexual_orientations;
      }
    }
  },
};
</script>